import React from 'react';
import { useTranslation } from 'react-i18next';
import Form, { FormTemplate } from '../../../../molecules/Form/Form';
import { FormContainerModifier } from '../../../../molecules/Form';
import { ButtonMinorAction } from '../../../../molecules/Btn/ButtonWrapper';
import { Namespace } from '../../../../../translation/namespace';
import { TooltipPlacement } from '../../../../atoms/Tooltip';
import IForm from '../../../../../types/IForm';
import { SVGIcon } from '../../../../atoms/SVG';
import { ContentWrapperAction as Action } from '../../../../blocks/ContentWrapper/ContentWrapper.types';

type MoveContentBlockFormProps = {
  actionKey: keyof typeof Action;
  actionKeyToIcon: SVGIcon;
  beforeSubmit: () => void;
  position: number | string | { positionImage: number | string; positionText: number | string };
  elementType: string;
  form: IForm;
  isActionDisabled: boolean;
  onFailure: () => void;
  onSuccess: () => void;
};

export function MoveContentBlockForm({
  actionKey,
  actionKeyToIcon,
  beforeSubmit,
  position,
  elementType,
  form,
  isActionDisabled,
  onFailure,
  onSuccess,
}: MoveContentBlockFormProps) {
  const { t } = useTranslation(Namespace.ContentWrapper);

  return (
    <Form
      id={`content-wrapper-${actionKey}-form`}
      model={form}
      containerModifier={[FormContainerModifier.NO_PADDING]}
      beforeSubmit={beforeSubmit}
      onSuccess={onSuccess}
      onFailure={onFailure}
      allowNavigationOnUnsavedChanges
      submittableWithoutChange
    >
      <FormTemplate>
        {model => (
          <>
            {model.hiddenFields}
            <ButtonMinorAction
              type="submit"
              text={
                isActionDisabled
                  ? t(`${Namespace.ContentWrapper}:actions.${actionKey}.${elementType}.disabled`)
                  : t(`${Namespace.ContentWrapper}:actions.${actionKey}.${elementType}.text`, {
                      position,
                    })
              }
              icon={actionKeyToIcon}
              ariaDisabled={isActionDisabled}
              tooltipPlacement={TooltipPlacement.TOP}
            />
          </>
        )}
      </FormTemplate>
    </Form>
  );
}
